import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useHttpClient } from "./hooks/http-hook";

import "./Form.css";
import { AuthContext } from "./context/auth-context";
import LoadingSpinner from "./LoadingSpinner/LoadingSpinner";
import Modal from "./Modal";

const Signup = () => {
  const auth = useContext(AuthContext);
  const history = useHistory();
  const { register, handleSubmit, errors, watch } = useForm(); // initialise the hook
  const { error, sendRequest, clearError, isLoading } = useHttpClient();

  const confirmSignup = async (userData) => {
    const { firstName, lastName, email, password, confirmPassword } = userData;
    try {
      const responseData = await sendRequest(
        process.env.REACT_APP_SIGNUP,
        "POST",
        JSON.stringify({
          firstName,
          lastName,
          email,
          password,
          confirmPassword,
        }),
        {
          "Content-Type": "application/json",
        }
      );
      auth.login();
      history.push("/");
    } catch (err) {}
  };

  const onSubmit = (data) => {
    confirmSignup(data);
  };

  return (
    <React.Fragment>
      {isLoading && (
        <div style={{ width: "100px", margin: "0 auto" }}>
          <LoadingSpinner />
        </div>
      )}
      {error && (
        <Modal error={error || "An error occurred"} onClear={clearError} />
      )}
      <form className="authentication-form" onSubmit={handleSubmit(onSubmit)}>
        <div className="container form-group form-area my-auto mx-auto">
          <div className="form-heading text-center">
            <h3 className="text-info text-uppercase">Signup </h3>
          </div>
          <label htmlFor="firstName" className="font-weight-bold">
            First Name
          </label>
          <input
            className="form-control"
            name="firstName"
            placeholder="First Name"
            ref={register({ required: true })}
          />
          {errors.firstName && (
            <div className="small text-danger">First name is required.</div>
          )}
          <label
            htmlFor="lastName"
            className="font-weight-bold form-label pt-3"
          >
            Last Name
          </label>
          <input
            placeholder="Last Name"
            className="form-control"
            name="lastName"
            ref={register({ required: true })}
          />
          {errors.lastName && (
            <div className="small text-danger">Last name is required</div>
          )}
          <label htmlFor="email" className="font-weight-bold form-label pt-3">
            Email
          </label>
          <input
            type="email"
            className="form-control"
            name="email"
            placeholder="Email"
            ref={register({ required: true })}
          />
          {errors.email && (
            <div className="small text-danger">Email is required</div>
          )}
          <label
            htmlFor="password"
            className="font-weight-bold form-label pt-3"
          >
            Password
          </label>
          <input
            type="password"
            className="form-control"
            placeholder="Password"
            name="password"
            ref={register({ required: true, minLength: 6 })}
          />
          <div className="small lead text-muted">
            Password must be atleast 6 characters long
          </div>
          {errors.password && (
            <div className="small text-danger">
              Minimum length of password must be 6
            </div>
          )}
          <label
            htmlFor="confirmPassword"
            className="font-weight-bold form-label pt-3"
          >
            Confirm Password
          </label>
          <input
            type="password"
            name="confirmPassword"
            className="form-control"
            ref={register({
              validate: (value) => value === watch("password"),
            })}
            placeholder="Confirm Password"
          />
          {!errors.password && errors.confirmPassword && (
            <div className="small text-danger">Passwords do not match</div>
          )}
          <div className="py-4 text-center">
            <input type="submit" className="btn btn-outline-info" />
          </div>
        </div>
        {error && <div>Error</div>}
      </form>
    </React.Fragment>
  );
};

export default Signup;
